import * as React from "react";
import SimpleTextFilter from "src/components/Lists/Base/CompleteList/Filters/TextFilter";

export default () => {
  const cols = [
    {
      Header: "Dimension",
      accessor: "dimension.str_representation",
      Cell: ({ value }) => {
        return <div>{value}</div>;
      },
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Kod",
      accessor: "dimension_entry_id",
      Cell: ({ value }) => {
        return <div>{value}</div>;
      },
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Beskrivning",
      accessor: "description",
      Cell: ({ value }) => {
        return <div>{value}</div>;
      },
      Filter: SimpleTextFilter,
      filter: "text",
    },
  ];

  return cols;
};
